import { createSlice } from '@reduxjs/toolkit';
import {
    hasAccepted,
    getBallonsByParticipant,
    getAvailableBallons,
    getWinners,
    popBallon,
    signTerm,
    postResgate,
    fetchAndOpenModal,
    fetchAvailableBallons,
    hasActive
} from './VertemGiftApi';

const initialState = {
    hasAcceptedTerm: null,
    ballonsByParticipant: [],
    availableBallons: [],
    isModalOpen: false,
    winners: [],
    poppedBallon: null,
    isLoaded: null,
    isPopingBallonLoading: false,
    isSigningTerm: false,
    isPostingResgate: false,
    errorOnPopBallon: false,
    errorOnSignTerm: null,
    errorOnPostResgate: null,
    isFullFilled: null,
    isActiveGift: null
};

const vertemGiftSlice = createSlice({
    name: 'vertemGiftSlice',
    initialState,
    reducers: {
        setAvailableBallons: (state, action) => {
            state.availableBallons = action.payload;
        },
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
        },
        setPoppedBallon: (state, action) => {
            state.poppedBallon = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBallonsByParticipant.fulfilled, (state, action) => {
                state.ballonsByParticipant = action.payload
            })
            .addCase(getWinners.fulfilled, (state, action) => {
                state.winners = action.payload
            })
            .addCase(hasAccepted.fulfilled, (state, action) => {
                state.hasAcceptedTerm = action.payload
            })
            .addCase(popBallon.pending, (state) => {
                state.isPopingBallonLoading = true;
                state.errorOnPopBallon = null;
            })
            .addCase(popBallon.fulfilled, (state, action) => {
                state.isPopingBallonLoading = false;
                state.poppedBallon = action.payload;
            })
            .addCase(getAvailableBallons.fulfilled, (state, { payload }) => {
                state.availableBallons = payload;
            })
            .addCase(popBallon.rejected, (state, { payload }) => {
                state.isPopingBallonLoading = false;
                state.errorOnPopBallon = true;
            })
            .addCase(signTerm.pending, (state) => {
                state.isSigningTerm = true;
                state.errorOnSignTerm = null;
            })
            .addCase(signTerm.fulfilled, (state) => {
                state.isSigningTerm = false;
                state.hasAcceptedTerm = true;
            })
            .addCase(signTerm.rejected, (state, { payload }) => {
                state.isSigningTerm = false;
                state.errorOnSignTerm = payload;
            })
            .addCase(postResgate.pending, (state) => {
                state.isPostingResgate = true;
                state.errorOnPostResgate = null;
                state.isModalOpen = false;
                state.isFullFilled = false;
            })
            .addCase(postResgate.fulfilled, (state) => {
                state.isPostingResgate = false;
                state.isModalOpen = false;
                state.isFullFilled = true;
            })
            .addCase(postResgate.rejected, (state, { payload }) => {
                state.isPostingResgate = false;
                state.errorOnPostResgate = payload;
            })
            .addCase(fetchAvailableBallons.fulfilled, (state, { payload }) => {
                state.availableBallons = payload;
                state.isLoaded = true;
            })
            .addCase(fetchAndOpenModal.fulfilled, (state, { payload }) => {
                state.availableBallons = payload;
                state.isModalOpen = true;
                state.isLoaded = true;
            })
            .addCase(hasActive.fulfilled, (state, { payload }) => {
                state.isActiveGift = payload.isActive;
            })
    },
});


export const { setAvailableBallons, openModal, closeModal } = vertemGiftSlice.actions;

export default vertemGiftSlice.reducer;
